<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Greeting Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editGreeting">Edit Greeting</button>
                </div>
            </div>
            <div class="table-responsive" v-if="greeting">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{greeting.bannerId}}</td>
                    </tr>
                    <tr>
                        <th>Message</th>
                        <td>{{greeting.bannerMessage}}</td>
                    </tr>
                    <tr>
                        <th>URL</th>
                        <td>{{greeting.destinationURL}}</td>
                    </tr>
                  <tr>
                    <th>Start Date/Time</th>
                    <td>{{greeting.start_dateFmt}}</td>
                  </tr>
                  <tr>
                    <th>Start Date/Time</th>
                    <td>{{greeting.end_dateFmt}}</td>
                  </tr>
                  <tr>
                    <th>Corporation Name</th>
                    <td>{{greeting.corporationName}}</td>
                  </tr>
                  <tr>
                    <th>Display Order</th>
                    <td>{{greeting.displayOrder}}</td>
                  </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="greeting.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewGreeting',
        components: {
            LTable,
        },
        created (){
            console.log('inside view greeting')
        this.$store.dispatch('GETSELECTEDGREETING', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedGreeting)
            this.greeting = this.selectedGreeting;
        })
    },
    data () {
        return {
          greeting: {}
        }
    },
    methods: {
        editGreeting(){
            this.$router.push({ name: 'EditGreeting', params: { id: this.greeting.bannerId}})
        },
    },
    computed: {...mapGetters([
        'selectedGreeting'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Greetings/GreetingDetails.vue